import { GamePoint } from '../interfaces/common-interfaces';
import { BG_LAYER_HEIGHT } from './game-constants';

type PathPoints = Array<GamePoint[]>;

interface PathOffset {
	startPoint: GamePoint;
	stepOffset: [number, number];
	pathOffset: [number, number][][];
};

export const PATH_OFFSET: PathOffset = {
	startPoint: [820, 1050],
	stepOffset: [40, 20],
	pathOffset: [
		[
			[0, 0],
			[1, 1],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[0.5, 0.5],
			[-1, 1],
			[-1, 1],
			[-1, 1],
		],
		[
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
		],
		[
			[2, 2],
			[2, 2],
			[1, 1],
			[2, 3],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1],
			[1, 1],
			[1, 1],
			[1, 1],
			[1, 1],
			[1, 1],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[1, 1.5],
			[-2, 2],
			[-2, 2],
			[-2, 2],
		],
		[
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-2, 2.5],
			[-0.5, 0.5],
			[2, 2],
			[2, 2],
			[1, 1],
		],
		[
			[2, 2.5],
			[2, 2.5],
			[2, 2.5],
		],
		[
			[2, 2.5],
			[2, 2.5],
			[2, 2.5],
			[2, 2.5],
		]
	],
}
export const PATH_POINTS: PathPoints = [];
function getPoint(prevPoint: GamePoint, offset: [number, number], step: [number, number]): GamePoint {
	return [prevPoint[0] + (offset[0] * step[0]), prevPoint[1] + (offset[1] * -step[1])];
}
export function generatePathPoints(resultPath: PathPoints, pathOffset: PathOffset) {
	pathOffset.pathOffset.forEach((location, index) => {
		if (!resultPath[index]) resultPath[index] = [];

		location?.forEach((point, i) => {
			if (point) {
				const prevPoint = i == 0 && index == 0 ? pathOffset.startPoint : 
													i == 0 ? resultPath[index - 1][ resultPath[index - 1].length - 1] : resultPath[index][i - 1];
				resultPath[index][i] = getPoint(prevPoint, point, pathOffset.stepOffset);
			}
		});
	});
}
export const NotepadPathPoints: GamePoint[] = [
	[1280, 720],
	[1240, 700],
	[840, 500],
	[1000, 280],
	[1560, -100],
	[1760, -330],
	[1360, -560],
	[560, -1000],
	[500, -1360],
]